import {Box, IconButton, Typography} from '@mui/material';
import './DocExplorerHeader.scss';
import ArrTooltipWrapper from '../../common/arr-tooltip-wrapper/ArrTooltipWrapper';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {t} from 'i18next';
import {Trans} from 'react-i18next';

export const TEST_IDS = {
  CONTAINER: 'doc-explorer-header',
  TITLE: 'doc-explorer-title',
  TOOLTIP_BUTTON: 'tooltip-button',
  INFO_ICON: 'info-icon',
} as const;

const DocExplorerHeader = () => {
  return (
    <Box className="doc-explorer-header" data-testid={TEST_IDS.CONTAINER}>
      <Typography className="headline" data-testid={TEST_IDS.TITLE}>
        {t('docExplorer.header.title')}
        <ArrTooltipWrapper
          title={t('docExplorer.header.tooltipTitle')}
          trigger={
            <IconButton
              aria-label="Info"
              className="info-icon-button"
              data-testid={TEST_IDS.TOOLTIP_BUTTON}
            >
              <InfoOutlinedIcon className="info-icon" fontSize="medium" />
            </IconButton>
          }
        >
          <Typography className="preline-text" data-testid={`doc-explorer-header-typography`}>
            <Trans
              i18nKey="docExplorer.header.tooltip"
              components={{bold: <strong data-testid={`doc-explorer-header-strong`} />}}
            />
          </Typography>
        </ArrTooltipWrapper>
      </Typography>
    </Box>
  );
};

export default DocExplorerHeader;
